import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/editModalSlice";
import { openModalDelete } from "../../store/slices/deleteModalPackageSlice";
import { getAllAds } from "../../store/slices/apiAdsSlice";
import EditModalAds from "./EditModalAds";
import { FaPencilAlt } from "react-icons/fa";
import DeleteModalAds from "./DeleteModalAds";

const TableItemsAds = () => {
  const dispatch = useDispatch();
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const adsData = useSelector((state) => state.apiAds.data);
  const adsArray = Array.isArray(adsData.data) ? adsData.data : [];

  const isEditModalOpen = useSelector((state) => state.editModal.isOpen);

  useEffect(() => {
    dispatch(getAllAds());
  }, [dispatch]);

  const handleEditItem = (id) => {
    setEditId(id);
    dispatch(openModal());
  };

  const handleDeleteItem = (id) => {
    setDeleteId(id);
    dispatch(openModalDelete(id));
  };

  const handleCloseEditModal = () => {
    setEditId(null);
    dispatch(closeModal());
  };

  function getStatusTextFromBoolean(value) {
    return value ? "Aktiv" : "Pasiv";
  }

  return (
    <>
      {adsArray?.map((item, index) => (
        <tr
          key={item.id}
          className={`border-b ${
            index % 2 === 0 ? "bg-white" : "bg-gray-50"
          } dark:bg-gray-800 dark:border-gray-700`}
        >
          <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
            {item.title}
          </td>

          <td className="px-6 py-4 text-gray-700 dark:text-gray-300 max-w-xs break-words">
            {item.description}
          </td>
          <td className="px-6 py-4 text-gray-700 dark:text-gray-300 max-w-xs break-words">
            {item.categoryName}
          </td>
          <td className="px-6 py-4">
            <td
              className={`px-2 py-1 p-1 rounded-full w-5 h-5 ${
                item.status === 1 ? "bg-green-500" : "bg-red-500"
              }`}
            >
              <label className="text-white">
                {getStatusTextFromBoolean(item.status)}
              </label>
            </td>
          </td>

          <td className="px-6 py-4">
            <img
              src={`https://back2.autoshkollaime.com/${item.image}`}
              alt={item.title}
              className="w-14 h-14 object-cover rounded shadow border border-gray-200"
            />
          </td>

          <td className="px-6 py-4 flex">
            <div className="flex items-center gap-3 flex-wrap">
              <button
                onClick={() => handleEditItem(item.id)}
                className="text-blue-500 hover:opacity-80 focus:outline-none"
                aria-label="Edit"
              >
                <FaPencilAlt
                  style={{ width: 20, height: 20, color: "#21C621" }}
                />
              </button>
              <button
                onClick={() => handleDeleteItem(item.id)}
                className="text-danger mx-1"
                aria-label="Delete"
              >
                <DeleteModalAds id={item.id} />
              </button>
            </div>
          </td>
        </tr>
      ))}

      <EditModalAds
        id={editId}
        isOpen={isEditModalOpen}
        onClose={handleCloseEditModal}
      />
    </>
  );
};

export default TableItemsAds;
